import { Alert, Container } from 'react-bootstrap';
import { Navigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../../routes/routes';
import { QuestionnaireResponses } from '../../../questionnaire/components/QuestionnaireResponses';
import { SurveyDetailTabs, SurveyHeader } from '../../components';
import { useSurveyAnswers, useSurveyDetail } from '../../hooks/useSurveyAdminData';

export default function SurveyAnswersPage() {
  const { surveyId: surveyIdParam } = useParams();
  const { survey, surveyId, isNew, error } = useSurveyDetail(surveyIdParam);
  const { answers, isLoading, error: answersError } = useSurveyAnswers(surveyId);

  if (isNew) {
    return <Navigate to={ROUTES.survey.settings('new')} replace />;
  }

  return (
    <Container fluid className="p-4">
      <SurveyHeader survey={survey} />
      {surveyId && <SurveyDetailTabs surveyId={surveyId} />}
      {error && <Alert variant="danger">{error}</Alert>}
      {answersError && <Alert variant="danger">{answersError}</Alert>}
      <QuestionnaireResponses responses={answers} isLoading={isLoading} />
    </Container>
  );
}
